import { Component } from 'react'
import { observer } from 'mobx-react'

import * as h from 'h'

import styles from './styles-advanced-filters.scss'

class TextFilter extends Component {
  render () {
    const { label, value, onChange, disabled } = this.props

    return h.div(h.ca(styles.textFilter),
      h.label(null,
        h.span(null, label),
        h.input({
          value,
          disabled,
          onChange: e => onChange(e.target.value),
          name: 'faculty text filter'
        })
      ))
  }
}

class SelectFilter extends Component {
  render () {
    const { label, initialValue, value, values, onChange, disabled } = this.props

    return h.div(h.ca(styles.textFilter),
      h.label(null,
        h.span(null, label),
        h.select({
          value,
          disabled,
          onChange: e => onChange(e.target.value),
          name: 'filter-by-topic selector'
        },
          [
            h.option({ key: '', value: '' }, initialValue),
            ...values.map(v => h.option({ key: v, value: v }, v))
          ]
        )
      ))
  }
}

@observer(['UiStore'])
export default class AdvancedFilters extends Component {
  // --------------------------------------------------------------------------
  // Actions
  // --------------------------------------------------------------------------

  flip = () => {
    this.props.UiStore.toggleAdvancedFilters()
  }

  // --------------------------------------------------------------------------
  // Helpers
  // --------------------------------------------------------------------------

  get show () {
    return this.props.UiStore.showAdvancedFilters
  }

  // --------------------------------------------------------------------------
  // Sub-components / Render
  // --------------------------------------------------------------------------

  get primaryFiltersBox () {
    const { projectFilters } = this.props.UiStore

    return h.div(h.ca(styles.primaryFiltersBox),
      h.h(SelectFilter, {
        label: 'Topics', // user-facing name for tags
        initialValue: 'All Topics', // user-facing name for tags
        value: projectFilters.tag,
        values: window.tagsList,
        onChange: value => { projectFilters.tag = value },
        disabled: projectFilters.faculty
      }),
      h.h(TextFilter, {
        label: 'Faculty',
        value: projectFilters.faculty,
        onChange: value => { projectFilters.faculty = value },
        disabled: projectFilters.tag
      })
    )
  }

  render () {
    return h.div(h.ca(styles.wrapper),
      h.z({ onClick: this.flip, ...h.ca(styles.hideShowLink) },
        `${this.show ? 'hide' : 'show'} advanced filters`),
      this.show ? this.primaryFiltersBox : null)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Explore/AdvancedFilters.js